import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { useBrandingData } from './DataProviders';
import { BtLink } from './BtLink';


const useStyles = makeStyles( theme => ({
  root: {
    ...theme.auctaneBrand,
    margin: '0 auto 20px',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '17px',
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
      textDecoration: 'none'
    }
  },
  preText: {
    marginRight: '3px'
  },
  image: {
    maxHeight: '20px',
    marginLeft: '1px'
  }
}));


export default function PoweredBy({ className='' }) {
  const classes = useStyles();
  const { powered_by: { name, logo_url, url } = {} } = useBrandingData();

  if( !name && !logo_url ) {
    return null;
  }

  return <BtLink className={`${classes.root} ${className}`} href={url} target="_blank">
    <span className={classes.preText}>Powered by</span>
    { logo_url ? (
      <img src={logo_url} alt={name} className={classes.image} />
    ):(
      <span className={classes.name}>{name}</span>
    )}
  </BtLink>
}